import type {ClientSession} from 'src/typings';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {AjaxService} from 'core/data-services/ajax.service';

export class UtilsDataService {
    public static serviceName = 'utilsDataService';

    public static ACTIVE_CLIENT_SESSIONS = 'active-client-sessions';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async getActiveClientSessionsList(): Promise<ClientSession[]> {
        return this.ajaxService
            .createRequest(UtilsDataService.ACTIVE_CLIENT_SESSIONS)
            .get();
    }
}